import { Schema } from "effect";
export const TTL = Schema.Struct({
    _nanoseconds: Schema.Int,
    _seconds: Schema.Int,
});
export const BaseFireStoreObject = Schema.Struct({
    timeToLive: TTL,
});
